import { useMemo } from 'react';
import {
  getAvailability,
  getEffectivePics,
  isDisplayable,
  isSellable,
} from '@services/dataService';
import useRegion from '@hooks/useRegion';

/**
 * Per-product availability over the current sales-area context.
 * Use this in PLPCard, ProductDetailHero, CompareCheckbox, and any wizard result card.
 *
 * Reads sales-entity from useRegion() → AppContext.state.salesEntity.
 *
 * @param {string} itemCode
 * @param {Object} [product] — pass the full product object if you need PICS fallback for guests
 * @returns {{availability, pics, displayable, sellable, entityCode}}
 */
export function useAvailability(itemCode, product = null) {
  const { salesEntity } = useRegion();
  const entityCode = salesEntity || null;

  return useMemo(() => {
    const availability = getAvailability(itemCode, entityCode);
    return {
      availability,
      pics: product
        ? getEffectivePics(product, entityCode)
        : availability?.pics ?? null,
      displayable: isDisplayable(itemCode, entityCode),
      sellable: isSellable(itemCode, entityCode),
      entityCode,
    };
  }, [itemCode, entityCode, product]);
}

export default useAvailability;
